import { useSyncExternalStore } from 'react';

/** Debajo de este ancho (el `md` de Tailwind) la app es de solo consulta. */
const CONSULTA_MOVIL = '(max-width: 767px)';

function suscribir(avisar: () => void): () => void {
  const consulta = window.matchMedia(CONSULTA_MOVIL);
  consulta.addEventListener('change', avisar);
  return () => consulta.removeEventListener('change', avisar);
}

/** `true` en pantallas de celular. Se reevalua al girar o redimensionar la ventana. */
export function useEsMovil(): boolean {
  return useSyncExternalStore(
    suscribir,
    () => window.matchMedia(CONSULTA_MOVIL).matches,
    () => false,
  );
}
